"use client";

import React, { useState, useEffect } from "react";
import { ToggleButton, ToggleButtonGroup } from "@mui/material";
import SunEditor from "suneditor-react";
import "suneditor/dist/css/suneditor.min.css";
import { BASE_URL } from "../../config";
import { useToken } from "../../Context/TokenContext";

const CustomPageEditor = ({
  label = "Custom Page Content",
  defaultValue = "", // existing HTML/string content
  onChange, // callback to parent
  editorMode,
  setEditorMode
}) => {
  const [editorContent, setEditorContent] = useState("");
  const [htmlContent, setHtmlContent] = useState("");
  const { jboId } = useToken();

  // if defaultValue changes externally, update local state
  useEffect(() => {
    if (editorMode === "html") {
      setHtmlContent(defaultValue || "");
    } else {
      setEditorContent(defaultValue || "");
    }
  }, [defaultValue, editorMode]);

  const handleEditorToggle = (_, newValue) => {
    if (newValue !== null) setEditorMode(newValue);
  };

  const handleEditorChange = (value) => {
    setEditorContent(value);
    onChange?.(value, value, htmlContent, "editor");
  };

  const handleTextareaChange = (e) => {
    const newHtmlContent = e.target.value;
    setHtmlContent(newHtmlContent);
    onChange?.(newHtmlContent, editorContent, newHtmlContent, "html");
  };

  return (
    <div className="w-full">
      <label className="font-medium font-poppins pt-3 text-gray-600 block">
        {label}
      </label>

      <ToggleButtonGroup
        color="primary"
        value={editorMode}
        exclusive
        onChange={handleEditorToggle}
        aria-label="Editor Mode"
        className="twenty-sixth-step mb-3"
      >
        <ToggleButton value="editor">Web Editor</ToggleButton>
        <ToggleButton value="html">HTML</ToggleButton>
      </ToggleButtonGroup>

      {editorMode === "editor" ? (
        <SunEditor
          setDefaultStyle="font-family: poppins; font-size: 15px;"
          setOptions={{
            height: 600,
            attributesWhitelist: { all: "style" },
            buttonList: [
              ["font", "fontSize", "bold", "subscript", "superscript", "underline"],
              ["fontColor", "hiliteColor", "outdent", "indent", "link"],
              ["codeView", "undo", "redo", "align", "list", "table"],
              ["image", "imageGallery", "video", "fullScreen", "preview"],
            ],
            imageGalleryUrl: `${BASE_URL}/gallery-uploads/CMS_gallery?jbo_id=${jboId}`,
            font: [
              "Arial",
              "Calibri",
              "Comic Sans",
              "Courier",
              "Poppins",
              "Times New Roman",
            ],
          }}
          setContents={editorContent}
          onChange={handleEditorChange}
        />
      ) : (
        <textarea
          name="postContent"
          rows={20}
          cols={74}
          value={htmlContent}
          onChange={handleTextareaChange}
          className="w-full border border-gray-300 rounded-md p-2 font-poppins text-sm"
        />
      )}
    </div>
  );
};

export default CustomPageEditor;
